var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefreshDownstream = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  stroke: "currentcolor",
  d: "M2.25 3.5c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25zm1.25-.75a.75.75 0 0 0-.75.75v2c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 0-.75-.75zM2.25 10.5c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25zm1.25-.75a.75.75 0 0 0-.75.75v2c0 .414.336.75.75.75h2a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 0-.75-.75zM9.5 12.25l.6.8.6.8a.25.25 0 1 1-.4.3l-1.5-2a.25.25 0 0 1 0-.3l1.5-2a.25.25 0 1 1 .4.3l-.6.8-.6.8h3A1.75 1.75 0 0 0 14.25 10V6a1.75 1.75 0 0 0-1.75-1.75h-3a.25.25 0 0 1 0-.5h3A2.25 2.25 0 0 1 14.75 6v4a2.25 2.25 0 0 1-2.25 2.25h-3Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefreshDownstream);
export default ForwardRef;